module.exports = __webpack_public_path__ + "img/seta_botao.90037730.png";